
export default [{
	path: '/invoices',
	component: () => import('@/components/invoices/List')
}]
